import React from "react"

export const components = {
    label: ({ children }) => (
      <sup>{children}</sup>
    ),
}